import type { CardPluginOptions } from '@atlaskit/editor-plugin-card';

interface Props {
	options: Pick<
		CardPluginOptions,
		| 'allowBlockCards'
		| 'allowDatasource'
		| 'allowEmbeds'
		| 'onClickCallback'
		| 'fullWidthMode'
		| 'linkPicker'
		| 'lpLinkPicker'
		| 'editorAppearance'
	>;
}

export function cardPluginOptions({ options }: Props): CardPluginOptions {
	return {
		allowBlockCards: options.allowBlockCards,
		allowDatasource: options.allowDatasource,
		allowEmbeds: options.allowEmbeds,
		onClickCallback: options.onClickCallback,
		fullWidthMode: options.fullWidthMode,
		linkPicker: options.linkPicker,
		lpLinkPicker: options.lpLinkPicker,
		editorAppearance: options.editorAppearance,
		// @ts-ignore Temporary solution to check for Live Page editor.
		__livePage: options.__livePage,
	};
}
